// Das Band „Neue Version von Schnittklar ist da -- Neu laden".
//
// Das Markup steht versteckt im Layout (in der Sprache der Seite); hier wird
// es nur aufgedeckt und der Knopf verdrahtet. Was der Klick auslöst,
// entscheidet der Aufrufer (lib/serviceWorker.ts, `applyUpdate`): dieses
// Modul weiß nichts von Workern, damit es in jsdom ohne einen prüfbar ist.

export const UPDATE_BANNER_SELECTOR = '[data-update-banner]'
export const UPDATE_RELOAD_SELECTOR = '[data-update-reload]'

/**
 * Zeigt das Band und ruft `onReload` beim Klick -- einmal: der Knopf wird
 * dabei gesperrt, weil ein zweiter Klick nur einen zweiten Reload-Zuhörer
 * anhängen würde. Falsch, wenn die Seite kein Band trägt (die Offline-Seite,
 * eine Seite ohne Layout).
 */
export function showUpdateBanner(root: ParentNode, onReload: () => void): boolean {
  const banner = root.querySelector<HTMLElement>(UPDATE_BANNER_SELECTOR)
  const button = banner?.querySelector<HTMLButtonElement>(UPDATE_RELOAD_SELECTOR) ?? null
  if (banner === null || banner === undefined || button === null) return false

  button.addEventListener(
    'click',
    () => {
      button.disabled = true
      onReload()
    },
    { once: true },
  )
  banner.hidden = false
  return true
}
